<app-access-item [icon]="icon()" [iconColor]="iconColor()" [hideOverflow]="true">
  <app-access-item-header>Direct Link</app-access-item-header>
  <app-access-item-body>
    @if (publicAccessLevel() === 'no_access') {
      Public link access is disabled
    } @else if (publicAccessLevel() === 'view_only') {
      @if (gallery().password_enabled) {
        People with the password can view
      } @else {
        People with the link can view
      }
    } @else {
      @if (gallery().password_enabled) {
        People with the password can review
      } @else {
        People with the link can review
      }
    }
  </app-access-item-body>
  <app-access-item-cta>
    <button
      appButton
      name="link-settings"
      location="public-access-item"
      [hasIcon]="true"
      (click)="editLink.emit()"
      color="simple-primary"
      spacing="1"
      height="1"
      shape="round"
    >
      <span>Manage</span>
      <app-svg src="/assets/icons/16/chevron-right.svg" size="-1"></app-svg>
    </button>
  </app-access-item-cta>
</app-access-item>
